import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { colors } from '../designTokens';

const useStyles = makeStyles({
    Footer: {
        paddingLeft: '16px',
    },
    PhoneNumber: {
        fontSize: '1em',
        color: 'rgba(255, 255, 255, 0.85)',
    },
    AddressText: {
        fontSize: '1em',
        color: 'rgba(255, 255, 255, 0.85)',
        lineHeight: 1.6,
    },
    Phone: {
        fontSize: '18px',
        fontWeight: 600,
        color: '#FFFFFF',
    },
    Address: {
        fontSize: '18px',
        fontWeight: 600,
        color: '#FFFFFF',
    },
    CopyRight: {
        fontSize: '12px',
        marginTop: '20px',
        color: 'rgba(255, 255, 255, 0.65)',
    },
});

const Footer = () => {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    return (
        <Box
            component="footer"
            sx={{
                marginTop: '50px',
                paddingTop: '32px',
                paddingBottom: '40px',
                backgroundColor: colors.kale700,
                color: colors.textOnDark,
            }}
        >
            <div className={classes.Footer} style={matches ? { width: '60%', margin: '0 auto' } : { width: '100%', paddingRight: '16px' }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                        <div className={classes.Address}>公司地址</div>
                        <div className={classes.AddressText}>新竹縣竹北市光明三路62號2F</div>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <div className={classes.Phone}>連絡電話</div>
                        <div className={classes.PhoneNumber}>0906698289</div>
                    </Grid>
                </Grid>
                <div className={classes.CopyRight}>
                    Copyright © {new Date().getFullYear()} WebSoft. All Rights Reserved.
                </div>
            </div>
        </Box>
    );
};

export default Footer;
